<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col-12 col-md-6 offset-md-3">
        <div class="card" v-if="!isError">
          <div class="card-body">
            <p v-if="isLoading" class="text-center">
              <fp-loading></fp-loading>
            </p>
            <div v-if="lead">
              <p class="text-center">
                <img
                  :src="require('../assets/brand.png')"
                  style="width: 150px"
                />
              </p>
              <h4 class="mt-2 text-center">คอนเฟิร์มการนัดชมห้องพัก</h4>
              <div class="card">
                <div class="card-body text-center">
                  <h5 class="card-title">
                    Property Id : {{ lead.propertyId }}
                  </h5>
                  <h6 class="card-subtitle mb-2 text-muted">
                    Case Id : {{ lead.objectId }}
                  </h6>
                  <table class="table">
                    <tr>
                      <th>ชื่อลูกค้า</th>
                      <td>{{ lead.name }}</td>
                    </tr>
                    <tr>
                      <th>วันที่ต้องการเข้าชมห้องพัก</th>
                      <td>
                        {{
                          moment(lead.tourDate.iso).format("DD/MM/YYYY HH:mm")
                        }}
                        น.
                      </td>
                    </tr>
                  </table>
                  <hr />
                  <div v-if="!isSuccess">
                    <b-form @submit.prevent="onSubmit" v-if="!isSaving">
                      <b-form-group
                        id="input-group-2"
                        label="ชื่อผู้คอนเฟิร์มนัด:"
                        label-for="input-2"
                      >
                        <b-form-input
                          id="input-2"
                          v-model="form.name"
                          placeholder="กรุณากรอกชื่อผู้คอนเฟิร์มนัด"
                          required
                        ></b-form-input>
                      </b-form-group>
                      <b-button block size="lg" type="submit" variant="success">
                        คอนเฟิร์มนัด
                      </b-button>
                    </b-form>
                    <p v-else class="text-center">
                      <fp-loading></fp-loading>
                    </p>
                  </div>
                  <div v-else>
                    <h6 class="text-success">
                      ขอบคุณสำหรับการคอนเฟิร์มนัด
                      กรุณาเตรียมพร้อมห้องพักสำหรับการเข้าชม
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="isError">
          <div class="card-body text-center">
            เกิดข้อผิดพลาด กรุณาติดต่อทีมงาน โทร 099 447 3322
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      moment: moment,
      leadId: this.$route.params.leadId,
      isLoading: true,
      isError: false,
      isSaving: false,
      isSuccess: false,
      lead: null,
      form: {
        name: "",
      },
    };
  },
  async mounted() {
    if (this.leadId) {
      try {
        let result = await axios({
          method: "POST",
          url: `${process.env.VUE_APP_RENTINI_PARSE_SERVER_URL}/functions/getLeadById`,
          headers: {
            "X-Parse-Application-Id": process.env.VUE_APP_RENTINI_PARSE_APP_ID,
            "Content-Type": "application/json",
          },
          data: {
            id: this.leadId,
          },
        });
        if (result.status === 200) {
          this.lead = result.data.result;
          if (this.lead.isTourConfirmed) {
            this.isSuccess = true;
          }
          this.isLoading = false;
        } else {
          this.isError = true;
        }
      } catch (error) {
        this.isError = true;
      }
    }
  },
  methods: {
    async onSubmit() {
      this.isSaving = true;
      try {
        await axios({
          method: "POST",
          url: `${process.env.VUE_APP_RENTINI_PARSE_SERVER_URL}/functions/confirmLeadTour`,
          headers: {
            "X-Parse-Application-Id": process.env.VUE_APP_RENTINI_PARSE_APP_ID,
            "Content-Type": "application/json",
          },
          data: {
            id: this.lead.objectId,
            formData: this.form,
          },
        });
        this.isSuccess = true;
      } catch (error) {
        console.log(error);
      }
      this.isSaving = false;
    },
  },
};
</script>

<style>
</style>